export const handleVendorPaidCodPrint = async (
  vendorId,
  fetchCodTransfers,
  vendorName = "Vendor"
) => {
  try {
    // Fetch all paid COD transfers (without pagination limit)
    const result = await fetchCodTransfers({
      vendorId,
      page: 1,
      limit: 10000,
    });

    if (result.error) {
      throw new Error(result.error.message || "Failed to fetch data");
    }

    const codTransferRes = result.data;
    const paidCodTransfers = codTransferRes?.data || [];
    const totalItems = codTransferRes?.totalItems || 0;

    // Calculate total amount
    const totalAmount = paidCodTransfers.reduce(
      (sum, transfer) => sum + (transfer.transferAmount || 0),
      0
    );

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .header {
              margin-bottom: 30px;
            }
            .header h2 {
              margin: 5px 0;
            }
            .header p {
              margin: 5px 0;
              color: #666;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 10px;
              text-align: left;
            }
            th {
              background: #1976d2;
              color: #fff;
              font-weight: bold;
            }
            td:nth-child(1) {
              text-align: center;
              width: 60px;
            }
            td:nth-child(3),
            th:nth-child(3) {
              text-align: right;
            }
            .total-row {
              font-weight: bold;
              background: #f5f5f5;
            }
            .total-row td {
              font-size: 16px;
            }
            .print-date {
              margin-top: 30px;
              color: #666;
              font-size: 12px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>${vendorName}</h2>
            <h3>Paid COD Transfers Report</h3>
            <p>Total Records: ${totalItems}</p>
          </div>

          <table>
            <thead>
              <tr>
                <th>SN</th>
                <th>Transfer ID</th>
                <th>Transfer Amount</th>
                <th>Transfer Date</th>
                <th>Shipments</th>
                <th>Added By</th>
              </tr>
            </thead>
            <tbody>
              ${paidCodTransfers
                .map(
                  (transfer, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${transfer.codTransferId || "N/A"}</td>
                  <td>Rs ${(transfer.transferAmount || 0).toFixed(2)}</td>
                  <td>${
                    transfer.transferDate
                      ? new Date(transfer.transferDate).toLocaleDateString()
                      : "N/A"
                  }</td>
                  <td>${transfer.shipmentDetails?.join(", ") || "N/A"}</td>
                  <td>${transfer.addedUser?.name || "N/A"}</td>
                </tr>
              `
                )
                .join("")}
              <tr class="total-row">
                <td colspan="2">Total</td>
                <td>Rs ${totalAmount.toFixed(2)}</td>
                <td colspan="4"></td>
              </tr>
            </tbody>
          </table>

          <div class="print-date">
            <p>Printed on: ${new Date().toLocaleString()}</p>
          </div>
        </body>
      </html>
    `);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 500);

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1500);

    return {
      totalAmount,
      totalRecords: totalItems,
    };
  } catch (error) {
    console.error("Print failed:", error);
    return {
      totalAmount: 0,
      totalRecords: 0,
    };
  }
};
